import Moment from 'moment';

function futureMonthValidator({ configs, input, msgs }) {
  let isCurrentMonthValid = false;
  if (configs && configs.FUTURE_MONTH_VALIDATOR_ACCEPT_CURRENT_MONTH === 'true') {
    isCurrentMonthValid = true;
  }
  const FORMAT = 'MM/YY';
  const today = new Moment();

  const isValidFormat = Moment(input, FORMAT).format(FORMAT) === input;

  if (!isValidFormat) {
    if (msgs && msgs.dateFormat) {
      return msgs.dateFormat;
    }
    return 'Please enter valid date using MM/YY format';
  }
  if (
    !Moment(input, FORMAT).isAfter(today, 'month') &&
    !(isCurrentMonthValid && Moment(input, FORMAT).isSame(today, 'month'))
  ) {
    if (msgs && msgs.futuredate) {
      return msgs.futuremonth;
    }
    return (msgs && msgs.msg) || 'Month must be in the future';
  }

  return null;
}

export default futureMonthValidator;
